module.exports = __webpack_public_path__ + "static/img/phone.ba7f9a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = 1444
// module chunks = 4